import { Box, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect } from "react";
import Metricas from "./Metricas";
import Reportes from "./Reportes";
import Metas from "./Metas";
import { useDispatch, useSelector } from "react-redux";
import { getClientesPaginados, getMetas, getProspectos, getReportes, getUsuariosFiltrados } from "../../action";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
const IndexReportes = () => {
  const dispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const userData = useSelector((state) => state.app.itemUsuario);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    //dispatch(getReportes(1, 10));
    dispatch(getMetas(""));
    dispatch(getUsuariosFiltrados(10));
    //dispatch(getProspectos("ca", 0, 999, "", "", "", 0, 0));
    //dispatch(getProspectos("va", 0, 999, "", "", "", 0, 0));
    //dispatch(getClientesPaginados(0, 999, "true"));
  }, []);

  return (
    <div className="contenido">
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Reportes" {...a11yProps(0)} />
          <Tab label="Métricas" {...a11yProps(1)} />
          {userData && userData.tipoCuenta !== 10 && (
            <Tab label="Metas" {...a11yProps(2)} />
          )}
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <Reportes />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Metricas />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Metas />
      </TabPanel>
    </div>
  );
};
export default IndexReportes;
